import { useTranslation } from 'react-i18next';

import type { DashboardResultOverview } from 'src/types/dashboard';
import { hasAggregates } from 'src/components/dashboard/helper';
import useSurveyRootStatisticsDataQuery from 'src/components/dashboard/hooks/query/useSurveyRootStatisticsDataQuery';

const useSurveyRootStatisticsData = (
  dashboardResults: DashboardResultOverview | undefined,
  enabled?: boolean,
) => {
  const { t } = useTranslation('common');
  const { data, isFetching, error, refetch } = useSurveyRootStatisticsDataQuery(
    dashboardResults?.dashboard_id,
    dashboardResults?.user_root_org_unit?.id,
    enabled,
  );

  const noData = !hasAggregates(data);
  const errorMsg =
    error === 'somethingWentWrong' ? t('somethingWentWrong') : error || '';

  return {
    data,
    isFetching,
    noData,
    errorMsg,
    refetch,
  };
};

export default useSurveyRootStatisticsData;
